export default "__VITE_ASSET__BvbvLF3E__"